import $ from 'jquery';
import '../vendor/jquery-livequery.min.js'
import '../vendor/jState';

const onOnce = (selector, func) => {
    const DOM = $('.main-container');
    DOM.livequery(selector, () => {
        func();
        DOM.expire(selector);
    });
};

// Block logic
const processInit = process => {

    let desktop = $(window).width() > 576;

    $(window).resize(() => {
        if(($(window).width() > 576) !== desktop) {
            location.reload();
        }
    });

    if ($(window).width() > 576) { // On desktop

        // Get all tabs
        const tabs = $(process).find('.processTitle');
        
        // Click handler
        tabs.on('click', function() {
            $(tabs).addClass('notActive');
            $(this).removeClass('notActive');
            $(process).find('.processBody').removeClass('p0 p1 p2 p3');
            $(process).find('.processBody').addClass(`p${Number(this.id.replace('pt', '')) - 1}`);
        });

    } else { // On mobile

        // Get all tabs
        const tabs = $(process).find('.processTitle');
        $(tabs).addClass('notActive'); // Set all tabs to unactive
    
        $(process).find('.processBody').removeClass('p0 p1 p2 p3');
        $(process).find('.processBody').css('display', 'none');
        
        for(let tab of tabs) {
            $(tab).css('display', 'flex');
        }
    
        // Copy processBody to all tabs
        const pBody = $(process).find('.processBody');
        $(pBody).detach();
        $(tabs).after(pBody);
    
        // Set the right processBody to show for the right tab
        $(process).find('.processBody').each(function(index) {
            $(this).addClass('p' + index);
        });
        
        // Click handler
        tabs.on('click', function() {
            $(`.p${Number(this.id.replace('pt', '')) - 1}`).toggleClass('displayBody');
            $(`.p${Number(this.id.replace('pt', '')) - 1}`).slideToggle('fast');
            $(this).toggleClass('notActive');
            $('#' + this.id).toggleClass('rotateChevron');
        });
        
    }

};

// Once document is loaded
$(document).ready(() => {
    const wrapper = '.processContainer';

    // Once the block has loaded on page (if there is any)
    onOnce(wrapper, () => {
        // Run init for all blocks on page
        $(wrapper).each((i, e) => {
            processInit(e);
        });
    });
});